/**
 * Default cost configuration values for Pulse 360.
 */
export const DEFAULT_COST_CONFIG = {
  phone_call_cost: 7.50,
  agent_chat_cost: 1.50,
  automated_conversation_cost: 0.00,
};

/**
 * Every metric Pulse 360 can render, and how its value should be formatted.
 * Shared by the Pulse 360 tab, My Pulse 360, and both configuration screens.
 */
export const METRIC_CATEGORIES = {
  active_unique_customers: 'count',
  conversations: 'count',
  messages: 'count',
  first_response_time: 'timedelta',
  agent_first_response_time: 'timedelta',
  handle_time: 'timedelta',
  median_handle_time: 'timedelta',
  fully_automated_conversations: 'percent',
  partially_automated_conversations: 'percent',
  feedback_score: 'score',
  automation_driven_cost_savings: 'currency',
  channel_cost_savings: 'currency',
  relationship_length: 'timedelta',
  abandonment_rate: 'percent',
  sales_leads: 'count',
  primary_customer_retention_rate: 'percent',
};

export const METRIC_IDS = Object.keys(METRIC_CATEGORIES);

/**
 * Selection limits for a Pulse 360 configuration. These mirror the `maxItems`
 * constraints on PulseConfiguration.yaml / MyPulse365Configuration.yaml in
 * base-api — the API rejects anything larger, so keep the two in sync.
 */
export const MAX_METRICS_PER_SECTION = 5;
export const MAX_SEGMENT_SLOTS = 2;
